import { PositionLabel } from '../types';

export function getPositionLabel(x: number, y: number): PositionLabel {
  const vertical = y < 33.33 ? 'top' : y < 66.66 ? 'middle' : 'bottom';
  const horizontal = x < 33.33 ? 'left' : x < 66.66 ? 'center' : 'right';
  return `${vertical}-${horizontal}` as PositionLabel;
}

export function formatPosition(x: number, y: number): string {
  return `${x.toFixed(1)}% ${y.toFixed(1)}%`;
}

export function getPositionDescription(
  label: PositionLabel,
  x: number,
  y: number,
): string {
  return `[${label}, ${formatPosition(x, y)}]`;
}
